"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyQuotationUnit = void 0;
var Vehicle_1 = require("./Vehicle");
var Total_1 = require("./Total");
var UnitPackage_1 = require("./UnitPackage");
function makeEmptyQuotationUnit() {
    return {
        unit: Vehicle_1.makeEmptyVehicle(),
        coverages: [],
        total: Total_1.makeEmptyTotal(),
        package: UnitPackage_1.makeEmptyUnitPackage(),
        deductibleOption: 1,
    };
}
exports.makeEmptyQuotationUnit = makeEmptyQuotationUnit;
//# sourceMappingURL=QuotationUnit.js.map